import { useState, useEffect } from "react";
import logo from "../assets/burgersson-logo.png";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-transparent px-4 md:px-6 md:px-16 py-4 flex items-start md:items-center justify-between">
      {/* Logo */}
      <Link to="/" className="flex items-center">
        <img src={logo} alt="Burgersson" className="h-16 md:h-32 w-auto" />
      </Link>

      {/* Desktop buttons — hide on scroll */}
      <div className="flex items-center gap-3 transition-all duration-500">
        <Link
          to="https://breakfastsociety.se/"
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 sm:px-6 py-2 rounded-full border border-foreground/40 text-[10px] sm:text-xs font-body font-semibold tracking-widest text-foreground uppercase hover:bg-foreground/10 transition-all"
          style={{
            opacity: scrolled ? 0 : 1,
            transform: scrolled ? "translateY(-12px)" : "translateY(0)",
            pointerEvents: scrolled ? "none" : "auto",
            transitionDuration: "500ms",
          }}
        >
          Breakfast
        </Link>
        <Link
          to="https://www.barleys.se/"
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 sm:px-6 py-2 rounded-full border border-foreground text-[10px] sm:text-xs font-body font-semibold tracking-widest uppercase transition-all bg-foreground text-background"
          style={{
            opacity: scrolled ? 0 : 1,
            transform: scrolled ? "translateY(-12px)" : "translateY(0)",
            pointerEvents: scrolled ? "none" : "auto",
            transitionDuration: "700ms",
          }}
        >
          barley's food factory
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
